import React from "react";
import moment from "moment";

import { Box, IconButton, Tooltip } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import BarChartIcon from "@mui/icons-material/BarChart";
import { TableColumnDef } from "../../components/DataTable";
import type { ContentLanguage } from "../../hooks/useContentLanguage";

type Props = {
  updateSurveyClickHandler: ({ row }: { row: any }) => void;
  deleteSurveyClickHandler: ({ row }: { row: any }) => void;
  surveyDetailsClickHandler: ({ row }: { row: any }) => void;
  canEdit: boolean;
  canDelete: boolean;
  lang: ContentLanguage;
};

export const getColumns = ({
  updateSurveyClickHandler,
  deleteSurveyClickHandler,
  surveyDetailsClickHandler,
  canEdit,
  canDelete,
  lang,
}: Props): TableColumnDef[] => [
  {
    header: "Frage",
    render: (row: any) => (lang === "de" ? row?.surveyQuestion_ger : row?.surveyQuestion) || "-",
    getValue: (row: any) => lang === "de" ? row?.surveyQuestion_ger : row?.surveyQuestion,
  },
  {
    header: "Art der Frage",
    render: (row: any) => row?.surveyType || "-",
    getValue: (row: any) => row?.surveyType,
  },
  {
    header: "Umfragen",
    render: (row: any) => row?.surveyField || "-",
    getValue: (row: any) => row?.surveyField,
  },
  {
    header: "Datum",
    render: (row: any) => moment(row?.createdAt).format("DD.MM.YYYY"),
    getValue: (row: any) => row?.createdAt,
  },
  {
    header: "Score",
    render: (row: any) => row?.coin ?? "-",
    getValue: (row: any) => row?.coin,
  },
  {
    header: "Einstellungen",
    render: (row: any) => (
      <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
        {canEdit && (
          <Tooltip title="Umfrage bearbeiten" arrow>
            <IconButton size="small" color="primary" onClick={() => updateSurveyClickHandler({ row })}>
              <CreateIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        <Tooltip title={`Ergebnisse anzeigen (${row?.count ?? 0} Antworten)`} arrow>
          <IconButton size="small" color="info" onClick={() => surveyDetailsClickHandler({ row })}>
            <BarChartIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        {canDelete && (
          <Tooltip title="Umfrage löschen" arrow>
            <IconButton size="small" color="error" onClick={() => deleteSurveyClickHandler({ row })}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    ),
  },
];
